<script>
import {mapGetters} from "vuex";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "EinspeisebeteiligungPayments",
  components: {
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters('einspeisebeteiligung', ['payments']),
    labels() {
      return this.payments?.map((payment) => payment.year);
    },
    values() {
      return this.payments?.map((payment) => payment.value);
    },
    series() {
      return [{
        name: 'Ausgezahlte Einspeisebeteiligung',
        data: this.values
      }]
    },
    chartOptions() {
      return {
        dataLabels: { enabled: false },
        legend: {
          show: false
        },
        stroke: {
          curve: 'smooth'
        },
        markers: {
          size: 7
        },
        xaxis: {
          categories: this.labels,
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        colors: ["#8C0F78"],
        chart: {
          type: 'line',
          height: 350,
          redrawOnParentResize: false,
          toolbar: {
            show: false
          }
        },
      };
    }
  }
}
</script>

<template>
  <div>
    <p class="font-weight-bold" style="padding-top: 30px">Entwicklung der Einspeisebeteiligung über die Jahre<br>(0,2 Cent/ kWh)</p>
    <!--<v-sparkline :labels="labels" :value="values" color="#8C0F78" type="trend" :smooth="16"
                 line-width="1.5" height="50px" class="mt-5" :show-labels="false" />-->
    <div>
      <apexchart height="150" type="line" :series="series" :options="chartOptions"></apexchart>
    </div>
    <v-slide-group show-arrows>
      <v-slide-item v-for="payment of payments" :key="payment.year">
        <v-sheet color="#d6e4de" class="mr-5 pa-4 payment-card">
          <span class="year-badge">{{payment.year}}</span>
          <p class="payment-label mb-0">Ausgezahlte<br>Einspeisebeteiligung</p>
          <p class="payment-value mb-0">€ {{ payment.value.toLocaleString()}}</p>
        </v-sheet>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<style scoped>
.payment-card {
  border-radius: 5px;
}

.payment-card p {
  color: #00874B;
}

.payment-label {
  font-size: 14px;
  line-height: 16px;
}

.payment-value {
  font-size: 40px;
  line-height: 40px;
  font-weight: bold;
}

.year-badge {
  background-color: #00874B;
  color: #d6e4de;
  font-size: 12px;
  padding: 1px 6px;
  text-align: center;
}

.v-slide-group__prev i,
.v-slide-group__next i {
  border-radius: 50%;
  background: #8C0F78 !important;
  color: white !important;
}
</style>
